import React, { useEffect, useState } from "react";
import { ThreeCircles } from 'react-loader-spinner';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import { BsFillArrowLeftSquareFill, BsFillArrowRightSquareFill} from "react-icons/bs";
import { data } from "jquery";

const TOP_KPIS_FIRST_PAGE = {
  gunDuration: 0,
  delta_soc: 0,
  energy_added: 0,
  charge_intereup_time: 0,
  battery_max_temp: 0,
  charge_duration: 0,
  median_roc: 0,
  gunAfterfullchargeInMin: 0,
  median_time_20_100: 0,
  medianinterrupt: 0,
  obc_max_temp: 0,
  fc10_80TimeInMin: 0
};

export default function HighlightsKpis({ gloablfilter, toggleChargingInterruption  }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const [faultactive, setFaultActive] = useState(TOP_KPIS_FIRST_PAGE);
  const [gunDuration, setgunDuration] = useState(0);
  const [delta_soc, setdelta_soc] = useState(0);
  const [energy_added, setenergy_added] = useState(0);
  const [charge_intereup_time, setcharge_intereup_time] = useState(0);
  const [battery_max_temp, setbattery_max_temp] = useState(0);
  const [charge_duration, setcharge_duration] = useState(0);
  const [median_roc, setmedian_roc] = useState(0);
  const [gunAfterfullchargeInMin, setgunAfterfullchargeInMin] = useState(0);
  const [median_time_20_100, setmedian_time_20_100] = useState(0);
  const [medianinterrupt, setmedianinterrupt] = useState(0);
  const [obc_max_temp, setobc_max_temp] = useState(0);
  const [slow, setSlow] = useState("slow");
  const [fc10_80TimeInMin, setfc10_80TimeInMin] = useState(0);
  const [currentRadioValueHigh, setCurrentRadioValueHigh] = useState("optionslow")
  const [median_soc_charge_end, set_Median_soc_charge_end] = useState(0)
  const [median_soc_charge_start, set_Median_soc_charge_start] = useState(0)
  const [median_slow_charging_current, set_Median_slow_charging_current] = useState(0)
  const [median_max_BMS_cell_voltage, set_Median_max_BMS_cell_voltage] = useState(0)
  const [median_min_BMS_cell_voltage, set_Median_min_BMS_cell_voltage] = useState(0)
  const [median_dynamic_BMS_max_cell_voltage, set_Median_dynamic_BMS_max_cell_voltage] = useState(0)
  const [median_dynamic_BMS_min_cell_voltage, set_Median_dynamic_BMS_min_cell_voltage] = useState(0)

  const [median_static_BMS_max_cell_voltage, set_Median_static_BMS_max_cell_voltage] = useState(0)
  const [median_static_delta_cell_voltage, set_Median_static_delta_cell_voltage] = useState(0)
  const [daily_energy_added, setdaily_energy_added] = useState(0)
  const [charge_cycle_per_day1, setcharge_cycle_per_day1] = useState(0)
  const [daily_gun_duration, setdaily_gun_duration] = useState(0)

  const [dynamic_delta_cell_voltage, setdynamic_delta_cell_voltage] = useState(0)
  const [static_BMS_min_cell_voltage, setstatic_BMS_min_cell_voltagee] = useState(0)

  const { isLoading, error, sendReq: fetchData } = useHttp();
  function median(numbers) {
    const sorted = Array.from(numbers).sort((a, b) => a - b);
    const middle = Math.floor(sorted.length / 2);

    if (sorted.length % 2 === 0) {
      if ((((sorted[middle - 1] + sorted[middle]) / 2).toFixed(2)) !== "NaN")
        return ((sorted[middle - 1] + sorted[middle]) / 2).toFixed(2);
      else
        return 0
    }
    if ((sorted[middle].toFixed(2)) !== "NaN")
      return sorted[middle].toFixed(2)
    else
      return 0
  }
  const appyData = (data) => {
    const res_result = data;

    let responce = {};
    let gunDuration = []
    let delta_soc = []
    let energy_added = []
    let charge_intereup_time = []
    let battery_max_temp = []
    let charge_duration = []
    let median_roc = []
    let gunAfterfullchargeInMin = []
    let median_time_20_100 = []
    let medianinterrupt = []
    let obc_max_temp = []
    let fc10_80TimeInMin = []
    let soc_charge_end = []
    let soc_charge_start = []

    let slow_charging_current = []
    let max_BMS_cell_voltage = []
    let min_BMS_cell_voltage = []
    let dynamic_BMS_max_cell_voltage = []
    let dynamic_BMS_min_cell_voltage = []
    let dynamic_delta_cell_voltage = []
    let static_BMS_max_cell_voltage = []
    let static_BMS_min_cell_voltage = []
    let static_delta_cell_voltage = []

    if (res_result.length !== 0) {
      let temp_result = res_result;

      data.forEach((obj1, index) => {
        if (obj1.gunDurationInMin.values["50.0"] != null)
          gunDuration.push(obj1.gunDurationInMin.values["50.0"])
        if (obj1.delta_soc.values["50.0"] != null)
          delta_soc.push(obj1.delta_soc.values["50.0"])
        if (obj1.EA_kWH.values["50.0"] != null)
          energy_added.push(obj1.EA_kWH.values["50.0"])
        if (obj1.InterruptDurationInMin.values["50.0"] != null)
          charge_intereup_time.push(obj1.InterruptDurationInMin.values["50.0"])
        if (obj1.BMS_Max_Cell_Temp.values["50.0"] != null)
          battery_max_temp.push(obj1.BMS_Max_Cell_Temp.values["50.0"])
        if (obj1.chargeDurationInMin.values["50.0"] != null)
          charge_duration.push(obj1.chargeDurationInMin.values["50.0"])
        if (obj1.ROC.values["50.0"] != null)
          median_roc.push(obj1.ROC.values["50.0"])
        if (obj1.gunAfterfullchargeInMin.values["50.0"] != null)
          gunAfterfullchargeInMin.push(obj1.gunAfterfullchargeInMin.values["50.0"])
        if (obj1.SC20_100TimeInMin.values["50.0"] != null)
          median_time_20_100.push(obj1.SC20_100TimeInMin.values["50.0"])
        if (obj1.NoofInterrupt.values["50.0"] != null)
          medianinterrupt.push(obj1.NoofInterrupt.values["50.0"])
        if (obj1.OBC_max_Temp.values["50.0"] != null)
          obc_max_temp.push(obj1.OBC_max_Temp.values["50.0"])
        if (obj1.FC10_80TimeInMin.values["50.0"] != null)
          fc10_80TimeInMin.push(obj1.FC10_80TimeInMin.values["50.0"])

        if (obj1.soc_end.values["50.0"] != null)
          soc_charge_end.push(obj1.soc_end.values["50.0"])
        if (obj1.soc_start.values["50.0"] != null)
          soc_charge_start.push(obj1.soc_start.values["50.0"])
        if (obj1.BMS_Pack_Current.values["50.0"] != null)
          slow_charging_current.push(obj1.BMS_Pack_Current.values["50.0"])
        if (obj1.BMS_Max_Cell_Voltage.values["50.0"] != null)
          max_BMS_cell_voltage.push(obj1.BMS_Max_Cell_Voltage.values["50.0"])
        if (obj1.BMS_Min_Cell_Voltage.values["50.0"] != null)
          min_BMS_cell_voltage.push(obj1.BMS_Min_Cell_Voltage.values["50.0"])
        if (obj1.BMS_max_cell_voltage_charge_end.values["50.0"] != null)
          dynamic_BMS_max_cell_voltage.push(obj1.BMS_max_cell_voltage_charge_end.values["50.0"])
        if (obj1.BMS_min_cell_voltage_charge_end.values["50.0"] != null)
          dynamic_BMS_min_cell_voltage.push(obj1.BMS_min_cell_voltage_charge_end.values["50.0"])

        if (obj1.BMS_max_cell_voltage_after_2_hour.values["50.0"] != null)
          static_BMS_max_cell_voltage.push(obj1.BMS_max_cell_voltage_after_2_hour.values["50.0"])
        if (obj1.delta_cell_voltage_after_2_hour.values["50.0"] != null)
          static_delta_cell_voltage.push(obj1.delta_cell_voltage_after_2_hour.values["50.0"])

        if (obj1.Dynamic_BMS_delta_cell_voltage.values["50.0"] != null)
          dynamic_delta_cell_voltage.push(obj1.Dynamic_BMS_delta_cell_voltage.values["50.0"])
        if (obj1.BMS_min_cell_voltage_after_2_hour.values["50.0"] != null)
          static_BMS_min_cell_voltage.push(obj1.BMS_min_cell_voltage_after_2_hour.values["50.0"])
      })

      setgunDuration(median(gunDuration))
      setdelta_soc(median(delta_soc))
      setenergy_added(median(energy_added))
      setcharge_intereup_time(median(charge_intereup_time))
      setbattery_max_temp(median(battery_max_temp))
      setcharge_duration(median(charge_duration))
      setmedian_roc(median(median_roc))
      setgunAfterfullchargeInMin(median(gunAfterfullchargeInMin))
      setmedian_time_20_100(median(median_time_20_100))
      setmedianinterrupt(median(medianinterrupt))
      setobc_max_temp(median(obc_max_temp))
      setfc10_80TimeInMin(median(fc10_80TimeInMin))
      set_Median_soc_charge_end(median(soc_charge_end))
      set_Median_soc_charge_start(median(soc_charge_start))
      set_Median_slow_charging_current(median(slow_charging_current))
      set_Median_max_BMS_cell_voltage(median(max_BMS_cell_voltage))
      set_Median_min_BMS_cell_voltage(median(min_BMS_cell_voltage))
      set_Median_dynamic_BMS_max_cell_voltage(median(dynamic_BMS_max_cell_voltage))
      set_Median_dynamic_BMS_min_cell_voltage(median(dynamic_BMS_min_cell_voltage))

      set_Median_static_BMS_max_cell_voltage(median(static_BMS_max_cell_voltage))
      set_Median_static_delta_cell_voltage(median(static_delta_cell_voltage))

      setdynamic_delta_cell_voltage(median(dynamic_delta_cell_voltage))
      setstatic_BMS_min_cell_voltagee(median(static_BMS_min_cell_voltage))

      responce = {
        totalvehiclecount: temp_result[0].total_vehicle_count.value
      }
      setTopData((prestate) => responce);
    } else {
      setgunDuration(median(gunDuration))
      setdelta_soc(median(delta_soc))
      setenergy_added(median(energy_added))
      setcharge_intereup_time(median(charge_intereup_time))
      setbattery_max_temp(median(battery_max_temp))
      setcharge_duration(median(charge_duration))
      setmedian_roc(median(median_roc))
      setgunAfterfullchargeInMin(median(gunAfterfullchargeInMin))
      setmedian_time_20_100(median(median_time_20_100))
      setmedianinterrupt(median(medianinterrupt))
      setobc_max_temp(median(obc_max_temp))
      setfc10_80TimeInMin(median(fc10_80TimeInMin))
      set_Median_soc_charge_end(median(soc_charge_end))
      set_Median_soc_charge_start(median(soc_charge_start))
      set_Median_slow_charging_current(median(slow_charging_current))
      set_Median_max_BMS_cell_voltage(median(max_BMS_cell_voltage))
      set_Median_min_BMS_cell_voltage(median(min_BMS_cell_voltage))
      set_Median_dynamic_BMS_max_cell_voltage(median(dynamic_BMS_max_cell_voltage))
      set_Median_dynamic_BMS_min_cell_voltage(median(dynamic_BMS_min_cell_voltage))

      set_Median_static_BMS_max_cell_voltage(median(static_BMS_max_cell_voltage))
      set_Median_static_delta_cell_voltage(median(static_delta_cell_voltage))

      setdynamic_delta_cell_voltage(median(dynamic_delta_cell_voltage))
      setstatic_BMS_min_cell_voltagee(median(static_BMS_min_cell_voltage))

      setTopData((prestate) => []);
    }
  }

  const appyDataNew = (data) =>{
    const uniqueEventDay = [...new Set(data.map(entry => entry.key.vehicleId))];
    const gunDurationsByVehicle = {};
    const EA_kWHByVehicle = {};
    const cyclePerDayByVehicle = {};

    data.forEach(entry => {
      const vehicleId = entry.key.vehicleId;
      const gunDuration = entry.gunDurationInMin.value;
      if (!gunDurationsByVehicle[vehicleId]) {
          gunDurationsByVehicle[vehicleId] = [];
      }
      gunDurationsByVehicle[vehicleId].push(gunDuration);
    });
    const nestedGunDurations = Object.values(gunDurationsByVehicle);

    data.forEach(entry => {
      const vehicleId = entry.key.vehicleId;
      const EA_kWH = entry.EA_kWH.value;
      if (!EA_kWHByVehicle[vehicleId]) {
        EA_kWHByVehicle[vehicleId] = [];
      }
      EA_kWHByVehicle[vehicleId].push(EA_kWH);
    });
    const nestedEA_kWH = Object.values(EA_kWHByVehicle);

    data.forEach(entry => {
      const vehicleId = entry.key.vehicleId;
      const cyclePerDay = entry.gun_end.doc_count;
      if (!cyclePerDayByVehicle[vehicleId]) {
        cyclePerDayByVehicle[vehicleId] = [];
      }
      cyclePerDayByVehicle[vehicleId].push(cyclePerDay);
    });
    const nestedCycleDay = Object.values(cyclePerDayByVehicle);

    function calculateMedian(numbers) {
      numbers.sort((a, b) => a - b);
      const n = numbers.length;
      const midpoint = Math.floor(n / 2);
      if (n % 2 === 1) {
          return numbers[midpoint];
      } else {
          return (numbers[midpoint - 1] + numbers[midpoint]) / 2;
      }
    }

    const gunDurationMedians = nestedGunDurations.map(sublist => calculateMedian(sublist));
    const EA_kWHMedians = nestedEA_kWH.map(sublist => calculateMedian(sublist));
    const cycleDayMedians = nestedCycleDay.map(sublist => calculateMedian(sublist));

    setdaily_gun_duration(median(gunDurationMedians))
    setdaily_energy_added(median(EA_kWHMedians))
    setcharge_cycle_per_day1(median(cycleDayMedians))
  }

  const appyslowDatanew = (data) =>{appyDataNew(data)}
  const appyfastDatanew = (data) =>{appyDataNew(data)}

  const appyslowData = (data) => { appyData(data) }
  const appyfastData = (data) => { appyData(data) }
  useEffect(() => {
    setCurrentRadioValueHigh("optionslow")
    setSlow("slow")
    fetchData({ url: API_URL_MAIN + "chargingpage/hightlightsslow", body: { filterdata: gloablfilter } }, appyslowData)
    fetchData({ url: API_URL_MAIN + "chargingpage/hightlightsslownew", body: { filterdata: gloablfilter } }, appyslowDatanew)
  }, [gloablfilter])

  const handleRadioChangehigh = (e) => {
    setCurrentRadioValueHigh(e.target.value);
  };
  const showslow = (e) => {
    e.preventDefault();
    const toggel = e.target.value
    if (toggel === "optionslow") {
      fetchData({ url: API_URL_MAIN + "chargingpage/hightlightsslow", body: { filterdata: gloablfilter } }, appyslowData)
      fetchData({ url: API_URL_MAIN + "chargingpage/hightlightsslownew", body: { filterdata: gloablfilter } }, appyslowDatanew)
      setSlow("slow")
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage/hightlightsfast", body: { filterdata: gloablfilter } }, appyfastData)
      fetchData({ url: API_URL_MAIN + "chargingpage/hightlightsfastnew", body: { filterdata: gloablfilter } }, appyfastDatanew)
      setSlow("fast")
    }
  }

  const handleRightArrowClick = () => {
    toggleChargingInterruption();
    setExpanded(!expanded);
  };
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div className={`col-lg-${expanded ? '12' : '5'} mb-3`}>
        <div className="chargingChartbox highlightBoxKpi">
          <div className="v-title chargingTitleBg">
            <div className="row p-2">
              <div className="col-lg-6 col-md-7 col-sm-9 col-9">
                <div className="p-2 text-start"><b>Highlights</b></div>
              </div>
              <div className="col-lg-6 col-md-5 col-sm-3 col-3 text-end">
                <div className="row">
                  <div className="col-lg-9 col-md-7 col-sm-7 col-7col-lg-12">
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="inlineRadioOptionsSlow" id="inlineRadioSlow1" value="optionslow" checked={currentRadioValueHigh === 'optionslow'} onChange={handleRadioChangehigh} onClick={showslow} />
                      <label className="form-check-label" htmlFor="inlineRadioSlow1">Slow</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="inlineRadioOptionsFast" id="inlineRadioFast2" value="optionfast" checked={currentRadioValueHigh === 'optionfast'} onChange={handleRadioChangehigh} onClick={showslow} />
                      <label className="form-check-label" htmlFor="inlineRadioFast2">Fast</label>
                    </div>
                  </div>
                  {!expanded ? (
                  <BsFillArrowRightSquareFill className="col-lg-3 col-md-5 col-sm-5 col-5 text-end" onClick={handleRightArrowClick} style={{fontSize:"23px", color:"#358696"}}/>
                  ) : (
                  <BsFillArrowLeftSquareFill className="col-lg-3 col-md-5 col-sm-5 col-5 text-end" onClick={handleRightArrowClick} style={{fontSize:"23px", color:"#358696"}}/>
                  )}
                </div>
              </div>
            </div>
          </div>
          {slow === "slow" && (
            <>
            {!expanded ? (
              <>
              <div className="mb-3 border-bottom">
                <div className="row chargingH5" style={{ textAlign: 'center' }}>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/1_ChargingGun_B.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{gunDuration}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median gun duration(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/ChargeDuration_B.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{charge_duration}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge duration(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/GunAfterFulCharge_B.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{gunAfterfullchargeInMin}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Gun after full charge(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/4_Median ROC_B.svg " /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{charge_intereup_time}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge interrupt time(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/MedianInterruption_B.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{medianinterrupt}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median interruption</small></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row chargingH5">
                <div className="col-lg-2 col-md-2 col-sm-4">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/MedianOBCMaxTemp_B.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(obc_max_temp).toFixed(1)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median OBC max temp(  ̊C)</small></p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_charging_current.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(median_slow_charging_current).toFixed(1)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median slow charging current</small></p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_bms_max_cell_voltage.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(median_max_BMS_cell_voltage).toFixed(3)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median Max BMS Cell voltage</small></p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_bms_min_cell_voltage.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(median_min_BMS_cell_voltage).toFixed(3)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median Min BMS Cell Voltage</small></p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_dynamic_bms_max_cell_voltage.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(median_dynamic_BMS_max_cell_voltage).toFixed(1)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Dynamic BMS Max cell voltage</small></p>
                      </div>
                    </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_dynamic_bms_min_cell_voltage.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(median_dynamic_BMS_min_cell_voltage).toFixed(1)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Dynamic BMS Min cell voltage </small></p>
                      </div>
                    </div>
                </div>
              </div>
              </>
            ) : (
              <>
              <div className="mb-3 border-bottom">
                <div className="row chargingH5" style={{ textAlign: 'center' }}>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/1_ChargingGun_B.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{gunDuration}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median gun duration(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/ChargeDuration_B.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{charge_duration}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge duration(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/GunAfterFulCharge_B.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{gunAfterfullchargeInMin}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Gun after full charge(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/4_Median ROC_B.svg " /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{charge_intereup_time}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge interrupt time(min)</small></p>
                    </div>
                  </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/MedianInterruption_B.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{medianinterrupt}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median interruption</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/MedianTimePercentage_B.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{median_time_20_100}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median time 20%-100%(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Median Delta SOC_B.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(delta_soc).toFixed(0)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median delta SOC(%)</small></p>
                    </div>
                  </div>
                </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_start_soc.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(median_soc_charge_start).toFixed(0)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median SOC at charge start</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_end_soc.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(median_soc_charge_end).toFixed(0)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median SOC charge end</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/ChargeInterruptTime_B.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{median_roc}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median ROC(%/hr)</small></p>
                    </div>
                  </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/MedianEnergyAdded_B.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{energy_added}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median energy added(Kwh)</small></p>
                    </div>
                  </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/MedianHVBatteryMaxTemp_B.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(battery_max_temp).toFixed(1)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median HV battery max temp(  ̊C)</small></p>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              <div className="row chargingH5">
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/MedianOBCMaxTemp_B.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(obc_max_temp).toFixed(1)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median OBC max temp(  ̊C)</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_charging_current.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(median_slow_charging_current).toFixed(1)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median slow charging current</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_bms_max_cell_voltage.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(median_max_BMS_cell_voltage).toFixed(3)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median Max BMS Cell voltage</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_bms_min_cell_voltage.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(median_min_BMS_cell_voltage).toFixed(3)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median Min BMS Cell Voltage</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_dynamic_bms_max_cell_voltage.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(median_dynamic_BMS_max_cell_voltage).toFixed(1)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Dynamic BMS Max cell voltage</small></p>
                      </div>
                    </div>
                </div>
                <div className="col">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_dynamic_bms_min_cell_voltage.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(median_dynamic_BMS_min_cell_voltage).toFixed(1)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Dynamic BMS Min cell voltage </small></p>
                      </div>
                    </div>
                </div>

                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/s_dynamic_delta_cell_voltage.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(dynamic_delta_cell_voltage).toFixed(1)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Dynamic delta cell voltage</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/s_static_bms_max_cell_voltage.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(median_static_BMS_max_cell_voltage).toFixed(1)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Static BMS Max cell voltage</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/s_static_bms_min_cell_voltage.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(static_BMS_min_cell_voltage).toFixed(1)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Static BMS Min cell voltage</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/s_static_delta_cell_voltage.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{Number(median_static_delta_cell_voltage).toFixed(1)}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median static delta cell voltage</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_daily_energy.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{daily_energy_added}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Daily Energy added</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_daily_cycle.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{charge_cycle_per_day1}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge cycles per day</small></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/slow_gun_duration.svg" /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{daily_gun_duration}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Daily gun duration</small></p>
                    </div>
                  </div>
                </div>
              </div>
              </>
          )}
            </>
          )}
          {slow === "fast" &&
            <>
            {!expanded ? (
              <>
              <div className="mb-3 border-bottom">
                <div className="row chargingH5" style={{ textAlign: 'center' }}>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/1_ChargingGun_O.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{gunDuration}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median gun duration(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/ChargeDuration_F.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{charge_duration}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge duration(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/GunAfterFulCharge_F.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{gunAfterfullchargeInMin}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Gun after full charge(min)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                  <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                    <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/4_Median ROC_O.svg " /> </div>
                    <div className="text-center">
                      <p className="h5 m-0">{charge_intereup_time}</p>
                      <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge interrupt time(min)</small></p>
                    </div>
                  </div>
                </div>
                  <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/MedianInterruption_O.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{medianinterrupt}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median interruption</small></p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div className="row chargingH5">
                <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_charging_current.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_slow_charging_current).toFixed(1)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median slow charging current</small></p>
                        </div>
                      </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_bms_max_cell_voltage.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_max_BMS_cell_voltage).toFixed(3)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Max BMS Cell voltage</small></p>
                        </div>
                      </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_bms_min_cell_voltage.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_min_BMS_cell_voltage).toFixed(3)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Min BMS Cell voltage</small></p>
                        </div>
                      </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_dynamic_bms_max_cell_voltage.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_dynamic_BMS_max_cell_voltage).toFixed(1)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Dynamic BMS Max cell voltage </small></p>
                        </div>
                      </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_dynamic_bms_min_cell_voltage.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_dynamic_BMS_min_cell_voltage).toFixed(1)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Dynamic BMS Min cell voltage </small></p>
                        </div>
                      </div>
                </div>
              </div>
              </>
            ) : (
              <>
                <div className="mb-3 border-bottom">
                  <div className="row chargingH5" style={{ textAlign: 'center' }}>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/1_ChargingGun_O.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{gunDuration}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median gun duration(min)</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/ChargeDuration_F.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{charge_duration}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge duration(min)</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/GunAfterFulCharge_F.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{gunAfterfullchargeInMin}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Gun after full charge(min)</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/4_Median ROC_O.svg " /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{charge_intereup_time}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge interrupt time(min)</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/MedianInterruption_O.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{medianinterrupt}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median interruption</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/MedianTimePercentage_O.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{fc10_80TimeInMin}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median time 10%-80%(min)</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/Median Delta SOC_O.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(delta_soc).toFixed(0)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median delta SOC(%)</small></p>
                      </div>
                    </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_start_soc.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_soc_charge_start).toFixed(0)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median SOC at charge start</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_end_soc.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_soc_charge_end).toFixed(0)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median SOC charge end</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/ChargeInterruptTime_O.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{median_roc}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median ROC(%/hr)</small></p>
                      </div>
                    </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/MedianEnergyAdded_O.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{energy_added}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median energy added(Kwh)</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/MedianHVBatteryMaxTemp_F.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(battery_max_temp).toFixed(1)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median HV battery max temp(  ̊C)</small></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row chargingH5">
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_charging_current.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_slow_charging_current).toFixed(1)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median slow charging current</small></p>
                        </div>
                      </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_bms_max_cell_voltage.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_max_BMS_cell_voltage).toFixed(3)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Max BMS Cell voltage</small></p>
                        </div>
                      </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_bms_min_cell_voltage.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_min_BMS_cell_voltage).toFixed(3)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Min BMS Cell voltage</small></p>
                        </div>
                      </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_dynamic_bms_max_cell_voltage.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_dynamic_BMS_max_cell_voltage).toFixed(1)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Dynamic BMS Max cell voltage </small></p>
                        </div>
                      </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                      <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                        <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_dynamic_bms_min_cell_voltage.svg" /> </div>
                        <div className="text-center">
                          <p className="h5 m-0">{Number(median_dynamic_BMS_min_cell_voltage).toFixed(1)}</p>
                          <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Dynamic BMS Min cell voltage </small></p>
                        </div>
                      </div>
                  </div>

                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/f_dynamic_delta_cell_voltage.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(dynamic_delta_cell_voltage).toFixed(1)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median dynamic delta cell voltage</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/f_static_bms_max_cell_voltage.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(median_static_BMS_max_cell_voltage).toFixed(1)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median Static BMS Max cell voltage</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/f_static_bms_min_cell_voltage.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(static_BMS_min_cell_voltage).toFixed(1)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median Static BMS Min cell voltage</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/f_static_delta_cell_voltage.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{Number(median_static_delta_cell_voltage).toFixed(1)}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Median static delta cell voltage</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_daily_energy.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{daily_energy_added}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Daily Energy added</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_daily_cycle.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{charge_cycle_per_day1}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Charge cycles per day</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-4 col205 highlight_five">
                    <div className="p-2 align-items-center" style={{ marginLeft: 0 }}>
                      <div className="chargingWidgetIcon1 text-center"><img src="/assets/img/highlightsKpi/Fast/fast_gun_duration.svg" /> </div>
                      <div className="text-center">
                        <p className="h5 m-0">{daily_gun_duration}</p>
                        <p className="m-0 chargingKpiSmallTxt"><small className="text-muted">Daily gun duration</small></p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
          )}
            </>
          }
        </div>
        {/* KPI section ends */}
      </div>
    </>
  )
}
